import { BoxProps, Box, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import PSkeleton from './Skeleton'
import { phaseType, specialtyType, exteriorType } from '../constants/skinPropertes'
import { colors } from '../theme/cssVariables'
import { useSkinTranslations } from '../hooks/useSkinTranslations'

const SkinCardInfo = ({
  children,
  isLoaded = true,
  specialtyKey,
  phaseKey,
  exteriorKey,
  displayName,
  ...rest
}: BoxProps & {
  isLoaded?: boolean
  specialtyKey?: specialtyType
  phaseKey?: phaseType
  exteriorKey?: exteriorType
  displayName: string
}) => {
  const nameStrs = displayName?.split('|')
  const { exteriorEnum, phaseEnum, specialtyEnum } = useSkinTranslations()

  const exterior = exteriorKey !== undefined ? exteriorEnum[exteriorKey] : undefined
  const phase = phaseKey !== undefined ? phaseEnum[phaseKey] : undefined
  const specialty = specialtyKey !== undefined ? specialtyEnum[specialtyKey] : undefined

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={1}
      width={'95%'}
      textAlign={'center'}
      color={colors.colorB1}
      fontSize={['xs', 'sm']}
      fontWeight={600}
      alignItems={'center'}
      {...rest}
    >
      <PSkeleton isLoaded={isLoaded} minH={'18px'} minW={'50%'}>
        <Text
          overflow={'hidden'}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          color={colors.colorB2}
          minH={'18px'}
        >
          <Trans>{nameStrs?.[0]}</Trans>
        </Text>
        <Text
          overflow={'hidden'}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          color={colors.colorB1}
          minH={'18px'}
        >
          {nameStrs?.[1] || ''}
        </Text>
      </PSkeleton>

      {phase && (
        <PSkeleton isLoaded={isLoaded} minH={'18px'} minW={'50%'}>
          <Text overflow={'hidden'} textOverflow="ellipsis" whiteSpace="nowrap">
            {phase}
          </Text>
        </PSkeleton>
      )}

      <PSkeleton isLoaded={isLoaded} minH={'18px'} minW={'50%'}>
        {exterior && (
          <Text
            color={colors.colorB3}
            fontSize={['smaller', 'xs']}
            overflow={'hidden'}
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {exterior}
          </Text>
        )}
      </PSkeleton>

      <PSkeleton isLoaded={isLoaded} minH={'18px'} minW={'50%'}>
        <Text
          overflow={'hidden'}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          color={colors.colorA1}
          fontSize={['smaller', 'xs']}
        >
          {specialty}
        </Text>
      </PSkeleton>
    </Box>
  )
}

export default SkinCardInfo
